import { statuses } from 'common/utils/constants';
/**
 *
 * @param {Object} property
 * @returns {Boolean}
 */
export function isValidPropertyStatus(property) {
    if (property && [statuses.ACTIVE].includes(property.statusId)) {
        return true;
    }
    return false;
}
